import React from 'react'
import Skeleton from '@mui/material/Skeleton';

export default function SkeletonComp({variant, width, height, style}) {
    return (
        <Skeleton variant={variant ? variant : 'text'} width={width ? width : '100%'} height={height ? height : '100%'} animation="wave" sx={style} />
    )
}